import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-list-input',
  templateUrl: './list-input.component.html',
  styleUrls: ['./list-input.component.css']
})
export class ListInputComponent {
  @Input() value: number = 0;
  @Input() items: number[] = [];
  @Input() itemsPrefix: string[] = [];
  @Input() currentIndex: number = 0;
  @Input() step: number = 1;
  @Input() disabled: boolean = false;
  @Input() editable: boolean = false;

  @ViewChild("input") myInputField: ElementRef;

  @Output() rowChange = new EventEmitter<number[]>();

  constructor() {}

  addLine(i: number)
  {
    this.items.push(0);
    this.rowChange.emit(this.items);
  }

  removeLine(i: number)
  {
    this.items.splice(i, 1);
    if (this.items.length === 0) this.items.push(0);
      this.rowChange.emit(this.items);
  }

  valueChange(e: any)
  {
    this.items[this.currentIndex] = e.target.value as number;
    this.rowChange.emit(this.items);
  }
}